import * as React from "react";

const UpDown = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    fill="none"
    viewBox="0 0 18 19"
    className={className}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_703_3141)"
    >
      <path d="M5.625 12.875 9 16.25l3.375-3.375M5.625 6.125 9 2.75l3.375 3.375"></path>
    </g>
    <defs>
      <clipPath id="clip0_703_3141">
        <path fill="#fff" d="M0 .5h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default UpDown;
